import { Box, IconButton, styled } from '@mui/material';

export const LogsPageContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4)
}));

export const DateNavContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 0, 4, 0)
}));

export const SynchronisationLogsFiltersContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr auto 1fr',
  alignItems: 'center',
  gap: theme.spacing(2),
  width: '100%'
}));

export const SynchronisationLogsDateNavigationContainer = styled(Box)({
  justifySelf: 'center'
});

export const SynchronisationLogsRefreshContainer = styled(Box)({
  justifySelf: 'end'
});

export const SynchronisationLogsRefreshButton = styled(IconButton)(
  ({ theme }) => ({
    flexShrink: 0,
    color: theme.palette.text.primary,
    backgroundColor: theme.vars.palette.secondary.container,
    '&:hover': {
      backgroundColor: theme.vars.palette.secondary.container
    }
  })
);
